export const COLUMN_HEADER = {
  fileName: "File Name",
  aircraftModel: "Aircraft Model",
  tailNumber: "Tail Number",
  serialNumber: "Serial Number",
  createdOn: "Created On",
  status: "Status",
  actions: "Actions",
};

export const HEADER_BAR = {
  download: "Download",
  edit: "Edit",
  preview: "Preview",
};

export const PLACEHOLDER_CONTENT = {
  noAccountSelected: "Select Account above to view your file history",
  beginConfiguration: "Click New above to begin configuring your software",
  noSearchResults:
    "No files matched your search string. Please enter a new string",
  searchFor: "Search for",
};
